// 英文
module.exports = {
    public: {
        confirm: 'Confirm',
        cancel: 'Cancel',
        reset: 'Reset',
        search: 'Search',
        RefreshSucceeded: 'Refresh Successful',
        noMoreData: 'No more data',
        pullingText: 'Pull to refresh...',
        ReleaseText: 'Release to refresh...',
        loadingText: 'Loading...',
        noData: 'No records',
        copyTxt: 'Copy',
        copySuccess: 'Copy successful',
        amount: 'Amount',
        buy: 'Buy',
        orderNo: 'Order Number',
        selectLang: 'Select Language',
        light: 'Light',
        dark: 'Dark',
        All: 'All',
        DigitalCurrency: 'Digital Currency',
        foreignExchange: 'Foreign Exchange',
        futures: 'Futures',
        stockIndex: 'Stock Index',
        stock: 'Stock',
        BalanceNot: 'Insufficient balance',
        optional: 'Optional',
        market: 'Market',
        USDTcontract: 'USDT Contract',
        Fiatcurrencycontract: 'Fiat Contract',
        spot: 'Spot',
        secondContract: 'Second Contract',
        emptyTxt: 'No records',
    },
    tabBar: {
        home: 'Home',
        market: 'Discover',
        trade: 'Trade',
        heel: 'Manage money matters',
        asset: 'Assets',
    },
    about: {
        title: 'About Us',
        version: 'Version',
        about: 'About',
        ProductIntroduction: 'Product Introduction',
        Termofservice: 'Terms of Service',
        PrivacyAgreement: 'Privacy Agreement',
        Riskstatement: 'Risk Statement',
        whitePaper: 'White Paper',
    },
    asset: {
        Overview: 'Overview',
        contract: 'Contract',
        wallet: 'Wallet',
        Totalassetvaluation: 'Total Asset Valuation',
        supportswithdrawal: 'All assets deposited are withdrawable',
        Recharge: 'Recharge',
        Contractaccount: 'Contract Account',
        Spotaccount: 'Spot Account',
        Walletaccount: 'Wallet Account',
        ValuationContractAssets: 'Contract Asset Valuation',
        profitloss: 'Profit/Loss',
        Transfer: 'Transfer',
        occupy: 'Lock',
        available: 'Available',
        Viewallpositions: 'View all positions',
        Valuationspotassets: 'Spot Asset Valuation',
        Hidezerobalanceassets: 'Hide zero balance assets',
        balance: 'Balance',
        ValuationWalletAssets: 'Wallet Asset Valuation',
        Withdrawal: 'Withdraw',
        Walletbalance: 'Wallet Balance',
        Cryptocurrencyrecharge: 'Crypto Recharge',
        Fiatcurrencyrecharge: 'Fiat Recharge',
        From: 'From',
        To: 'To',
        UsdtContractaccount: 'USDT Contract Account',
        FiatContractaccount: 'Fiat Contract Account',
        Currency: 'Currency',
        quantity: 'Quantity',
        availablebalance: 'Available Balance',
        Insufficientavailablebalance: 'Insufficient Balance',
        Transfersuccessful: 'Transfer Successful',
        flashcash: 'Flash Exchange',
        flashcashsuccessful: 'Flash Exchange Successful',
    },
    auth: {
        title: 'Real-name Authentication',
        gj: 'Nationality',
        tipsgj: 'Please select nationality',
        userName: 'Real Name',
        tips1: 'Please enter real name',
        IDNumber: 'ID Number',
        tips2: 'Please enter ID number',
        base: 'Basic Authentication',
        high: 'Advanced Authentication',
        zmz: 'ID Front Photo',
        bmz: 'ID Back Photo',
        tips3: 'Please upload front photo of ID',
        tips4: 'Please upload back photo of ID',
        btn: 'Submit',
        upbtn: 'Modify ID',
        subMsg: 'Submitted successfully, please wait for review',
        upMsg: 'Modified ID will be re-reviewed, confirm modification?',
        wait: 'Under review',
        fail: 'Authentication failed',
        success: 'Authentication successful',
        cardType: 'ID Type',
        idCard: 'ID Card',
        passport: 'Passport',
        driverlicense: 'Driver License',
        AssetCertification: 'Asset certification',
        AccountType: 'Account type',
        holdingamount: 'Holding amount',
        Accountscreenshot: 'Account screenshot',
        bankaccount: 'Bank account',
        IRAaccount: 'IRA account',
        stockaccount: 'Stock account',
        other: 'Other',
        AccountTypetips: 'Please select an account type',
        Accountscreenshottips: 'Please upload an account screenshot',
    },
    activity: {
        toptit: 'Benefit',
        inviteTxt: 'For each friend you invite, you can earn {amount} USD, supporting up to three levels of commission',
        invitebtn: 'Invite Commission',
        rechargeTxt: 'You can earn {amount}% commission from your downline’s recharge, supporting up to three levels of commission',
        rechargebtn: 'Recharge Commission',
        authTxt: 'Get {amount} USD upon successful identity verification',
        authbtn: 'Identity Verification',
        inviteRewardTxt: '<p><strong>Invite Friends, Easily Earn 30 USD</strong></p><p><br></p><p>1. Activity Objective</p><p><br></p><p>Target Users: Both new and existing users can participate, encouraging current users to actively invite friends to register and complete specified actions, thereby expanding the platform user base.</p><p>Core Appeal: Through the referral mechanism, enable new users to quickly onboard and generate viral growth, while allowing inviters to receive tangible rewards, enhancing user retention and loyalty.</p><p><br></p><p>2. Activity Period</p><p><br></p><p>From May 20, 2023 – ongoing (subject to periodic review or termination with prior notice)</p><p><br></p><p>3. Eligible Participants</p><p><br></p><p>Users who have completed platform registration and basic real-name verification can act as inviters (A);</p><p>Invitees (B) must register newly via an invitation link or code and complete real-name verification for the invitation to be valid.</p><p><br></p><p>4. Participation Rules</p><p><br></p><p>Invitation Method</p><p>Inviter (A) enters "Personal Page" → "Invite Friends" → copies exclusive invitation link/code.</p><p>Share the link/code with friends (B) who register via website or app.</p><p><br></p><p>Invitee Requirements</p><p>Invitee (B) must use the inviter’s link or code to complete first-time registration.</p><p>After registration, B must complete real-name verification and meet the minimum deposit requirement within 7 days (e.g., first deposit ≥ 1000 USD or equivalent tokens).</p><p><br></p><p>Tier Division</p><p>This activity supports up to three levels of commissions.</p><p>Level 1 (Direct referral): A directly invites B to register.</p><p>Level 2: B invites C; A earns second-level commission.</p><p>Level 3: C invites D; A earns third-level commission.</p><p>Beyond three levels (e.g., D invites E and onwards) no commissions are counted for A.</p><p><br></p><p>5. Reward Details</p><p><br></p><p>Level 1 Invitation Reward (Direct referral)</p><p>After invitee B deposits and completes real-name verification, inviter A receives 30 USD.</p><p><br></p><p>Level 2 Invitation Reward (Indirect referral)</p><p>When B becomes an inviter and directly invites user C who meets the same conditions (real-name verification + minimum deposit), A receives 15 USD.</p><p><br></p><p>Level 3 Invitation Reward (Further indirect referral)</p><p>When C invites D and conditions are met, A receives 10 USD.</p><p><br></p><p>Reward Distribution Method</p><p>The system automatically recognizes the three-level invitation relationship. When a downline (direct or indirect) meets the conditions, the corresponding reward will be automatically credited to inviter A’s account assets <strong>within 48 hours</strong>.</p><p><br></p><p><br></p><p>6. Operation Flow Example</p><p><br></p><p>A logs into ledger, goes to "Personal Page" → "Invite Friends" → copies exclusive invitation link/code.</p><p>A sends the link/code to friend B.</p><p>B clicks the link or enters the invitation code, goes to registration page → email registration → completes real-name verification and deposits ≥ 1000 USD.</p><p>After B completes verification and deposit, B contacts online support to claim reward; upon system approval, 30 USD will be automatically credited to A within 48 hours.</p><p>If B invites C who meets the conditions, system automatically credits 15 USD reward to A; if C invites D who meets the conditions, 10 USD is automatically credited to A.</p><p><br></p><p>&nbsp;</p><p>7. Risk Control and Notes</p><p><br></p><p>Anti-Fraud Measures</p><p>Each phone number/email can only be invited once; multi-dimensional info like same IP or ID will be monitored by the risk control system.</p><p>For the same device, network environment, or large numbers of low-quality registrations, manual review may be conducted in the backend, and rewards may be revoked if necessary.</p><p><br></p><p>Violation Penalties</p><p>If malicious fraud or cash-out behaviors are detected by inviter or invitee, the platform reserves the right to cancel all related rewards and freeze accounts unilaterally.</p><p><br></p><p>&nbsp;</p>',
        rechargeRewardTxt: '<p><strong>Earn Instant Commission from Downline Deposits</strong></p><p><br></p><p><strong>1. Activity Objective</strong></p><p><br></p><p>Target Users: Level 1 inviters (A) who have completed real-name verification can earn commission based on platform-set ratios when their downlines (B, C, D) make deposits, fostering “viral chains” and increasing user engagement.</p><p><br></p><p>Core Appeal: The “Deposit Commission” mechanism ties new users’ deposits with inviter benefits, creating a virtuous cycle of “invite-deposit-commission-reinvite” to promote platform fund retention and activity.</p><p><br></p><p><strong>2. Activity Period</strong></p><p><br></p><p>Ongoing: From May 20, 2023, valid long-term; commission rates or end dates may be adjusted with prior notice based on business needs.</p><p><br></p><p><strong>3. Eligible Participants</strong></p><p><br></p><p>Inviter A: Must be a real-name verified user who has successfully invited at least one downline to complete real-name verification (B).</p><p><br></p><p>Downlines B, C, D: Users invited by A or their downlines forming second and third levels; when these downlines deposit, A can earn commissions.</p><p><br></p><p><strong>4. Participation Rules</strong></p><p><br></p><p><strong>Hierarchy:</strong></p><p><br></p><p>Level 1 (Direct B): When B deposits (fiat or token, meeting minimum amount), system returns 1% commission on deposit amount to A (see commission rules below).</p><p>Level 2 (B invites C): When C deposits, A earns 0.5% commission on C’s deposit.</p><p>Level 3 (C invites D): When D deposits, A earns 0.3% commission (lower rate).</p><p>Only three-level commission is supported; deposits beyond these levels do not generate commissions for A.</p><p><br></p><p><strong>Deposit Channels and Minimum Amount:</strong></p><p><br></p><p>All platform-supported deposit channels (fiat or multi-chain crypto) are supported, but single deposit must be at least equivalent to 1000 USD to count for commission calculation;</p><p><br></p><p><strong>Commission Rates</strong></p><p><br></p><p>Level 1 B 1.0% e.g., B deposits 1000 USD, A gets 10 USD</p><p>Level 2 C 0.5% e.g., C deposits 1000 USD, A gets 5 USD</p><p><br></p><p>Level 3 D 0.3% e.g., D deposits 1000 USD, A gets 3 USD</p><p><br></p><p><strong>Commission Distribution Method</strong></p><p><br></p><p>The platform automatically credits commissions to inviter A’s trading account within 24 hours after downline deposit funds arrive;</p><p>Users can check each commission source, amount, and distribution time in “My Wallet” → “Commission Details.”</p><p><br></p><p><strong>5. Operation Flow Example</strong></p><p><br></p><p>A logs into the app → goes to “Personal Page” → “Invite Friends” → copies exclusive invitation link/code.</p><p>A provides the referral link/code to B.</p><p>B registers anew → completes real-name verification → deposits (at least 1000 USD).</p><p>After deposit arrives, system calculates: B’s total deposit × 1% = A’s commission. The commission is credited to A’s activity account within 24 hours.</p><p><br></p><p>After B becomes an inviter, B can invite C. If C deposits, the system calculates two levels of commissions for B and A:</p><p>B gets 1% of C’s deposit;</p><p>A gets 0.5% of C’s deposit.</p><p><br></p><p>C can invite D; if D deposits, three levels of commissions apply:</p><p>C gets 1% of D’s deposit;</p><p>B gets 0.5% of D’s deposit;</p><p>A gets 0.3% of D’s deposit.</p><p><br></p><p><strong>6. Risk Control and Notes</strong></p><p><br></p><p><strong>Prevent Malicious Arbitrage</strong></p><p><br></p><p>The same user must not perform circular deposits with their own account; the platform logs and monitors suspicious small multiple deposits or rapid large deposits with withdrawals, with manual review and commission cancellation if necessary.</p><p>Users exhibiting rapid cancellation and high-frequency behavior post-deposit may be considered malicious arbitrageurs, and related commissions will be canceled.</p><p><br></p><p><strong>Compliance Review</strong></p><p><br></p><p>If system or backend risk control detects money laundering or cash-out risks in invitees, the platform reserves the right to freeze the user and all related commissions, and report to regulatory authorities.</p><p><br></p><p><br></p>',
        authRewardTxt: '<p><strong>Get 50 USD Upon Real-Name Verification</strong></p><p><br></p><p>1. Activity Objective</p><p><br></p><p>Target Users: Both new and existing platform users (who have not completed real-name verification before) can participate. The aim is to attract new users to complete verification and encourage hesitant users to pass the process quickly.</p><p>Core Appeal: By distributing cash rewards, intuitively motivate users to complete real-name verification, improving risk control quality and KYC coverage to ensure compliant platform operation.</p><p><br></p><p>2. Activity Period</p><p><br></p><p>May 20, 2023 – ongoing</p><p><br></p><p>3. Eligible Participants</p><p><br></p><p>New Users: First-time registrants on ledger who complete real-name verification during the event period.</p><p>Existing Users: Users registered before the event who have not yet verified, must complete verification during the event to receive the reward.</p><p><br></p><p>4. Participation Rules</p><p><br></p><p>Real-Name Verification Requirements</p><p>Users must upload clear front and back photos of valid ID (ID card/passport/driver’s license), plus a half-body photo holding the ID;</p><p>Face recognition requires sufficient lighting, unobstructed features, and compliance with live detection;</p><p>Submission review generally completes within 24 hours.</p><p><br></p><p>Reward Amount</p><p>All users who successfully complete real-name verification during the event (both new and existing) will receive 50 USD.</p><p><br></p><p>Claim Method and Distribution Time</p><p>After passing verification, the system will credit 50</p><p>USD to the fiat contract account within 24 hours; withdrawal is allowed after 10 normal transactions.</p><p><br></p><p>If submission is incomplete or rejected, users must supplement materials and reapply; reward is granted only after approval.</p><p><br></p><p>5. Operation Flow Example</p><p><br></p><p>User logs into APP → “Real-Name Verification” → starts verification process.</p><p>Uploads front and back photos of ID/passport/driver’s license.</p><p>The system automatically compares ID info; if rejected, retake as prompted.</p><p>After approval, system credits 50</p><p>USD reward to “Fiat Contract Account” within 24 hours.</p><p><br></p><p>6. Risk Control and Notes</p><p><br></p><p>Prevent Fraudulent Claims</p><p><br></p><p>Each ID can claim the reward only once; multiple applications using the same IP or device with multiple IDs will trigger risk controls and require manual review or rejection.</p><p>Any obvious use of fake, altered, or photoshopped ID images will result in immediate rejection and account freeze.</p><p><br></p><p>Data Privacy Protection</p><p>The platform guarantees all ID and face recognition data are used solely for compliance risk control and KYC; data will not be leaked without user consent;</p><p>Uploaded documents and videos will be encrypted and stored according to laws and regulations after approval, meeting regulatory requirements.</p><p><br></p><p><br></p><p>&nbsp;</p>',
    },
    bill: {
        title: 'Transaction History',
        audit: 'Pending',
        success: 'Success',
        refuse: 'Refused',
        recharge: 'Recharge',
        recharge_currency: 'Coin Recharge',
        recharge_legal: 'Fiat Deposit',
        withdrawal: 'Withdrawal',
        withdrawal_currency: 'Coin Withdrawal',
        cancel_withdrawal_currency: 'Cancel Withdrawal',
        withdrawal_legal: 'Fiat Withdrawal',
        cancel_withdrawal_legal: 'Cancel Fiat Withdrawal',
        transfer: 'Transfer',
        usdt_contract_wallet: 'USDT Contract -> Wallet',
        legal_contract_wallet: 'Fiat Contract -> Wallet',
        coin_currency_wallet: 'Spot -> Wallet',
        wallet_usdt_contract: 'Wallet -> USDT Contract',
        wallet_legal_contract: 'Wallet -> Fiat Contract',
        wallet_coin_currency: 'Wallet -> Spot',
        finance_wallet: 'Finance -> Wallet',
        wallet_finance: 'Wallet -> Finance',
        usdt_contract_currency: 'USDT Contract -> Spot',
        finance_currency: 'Finance -> Spot',
        currency_usdt_contract: 'Spot -> USDT Contract',
        currency_finance: 'Spot -> Finance',
        legal_contract_currency: 'Legal contract -> Spot',
        currency_legal_contract: 'Spot -> Legal contract',
        recharge_reward: 'Subordinate recharge commission',
        auth_reward: 'Real-name authentication reward',
        flashcash: 'Flash Exchange',
        trade: 'Trade',
        create_order: 'Create Order',
        settlement_order: 'Order Settlement',
        cancel_order: 'Cancel Order',
        finance_return: 'Principal Return',
        finance_income: 'Investment Income',
        other: 'Other',
        commission_transfer: 'Commission Transfer',
        platform_gift: 'Platform Gift',
        system_regulation: 'Balance changes',
        freeze_thaw: 'Freeze or thaw',
        c2c_create_order: 'C2C Create Order',
        c2c_cancel_order: 'C2C Cancel Order',
        Currency: 'Currency',
        type: 'Type',
        SelectCurrency: 'Select Currency',
        SelectType: 'Select Type',
        SelectDate: 'Select Date',
        to: 'To',
        Contractfunds: 'Contract Funds',
        Spotfunds: 'Spot Funds',
        Walletfunds: 'Wallet Funds',
        RechargeRecord: 'Recharge Record',
        WithdrawalRecord: 'Withdrawal Record',
        virtualcoin: 'Virtual Coin',
        Legaltender: 'Fiat',
    },
    c2c: {
        limit: 'Limit',
        available: 'Available',
        price: 'Unit Price',
        needpay: 'You need to pay',
        willreceive: 'You will receive',
        Insufficientlimit: 'Insufficient limit',
        Exceedinglimit: 'Exceeding the limit',
        Exceedingavailable: 'Exceeding available amount',
        balance: 'Balance',
        InsufficientBalance: 'Insufficient balance',
        OrderHistory: 'Order History',
        quantity: 'Quantity',
        amountmoney: 'Amount',
        OrderNo: 'Order Number',
        inprogress: 'In progress',
        Completed: 'Completed',
        Cancelled: 'Cancelled',
        all: 'All',
        chat: 'Chat',
        picture: '[Image]',
        Read: 'Read',
        Unread: 'Unread',
        inputTips: 'Enter your message here',
        send: 'Send',
    },
    common: {
        title: 'All Functions',
        Depositcoins: 'Deposit Coins',
        Rechargefiatcurrency: 'Fiat Deposit',
        Withdraw: 'Withdraw',
        documentation: 'Copy Trade',
        Activecenter: 'Activity Center',
        Invitationforrebate: 'Invite for Rebate',
        Detailsoffunds: 'Fund Details',
        Positiondetails: 'Position Details',
        Notice: 'Information',
        Aboutus: 'About Us',
        helpcenter: 'Help Center',
        customer: 'Customer Service',
        Cryptocurrencywithdrawal: 'Crypto Withdrawal',
        Fiatmoneywithdrawal: 'Fiat Withdrawal',
        DepositcoinsTips: 'Simple process, quick coin purchase',
        RechargefiatcurrencyTips: 'Recharge USD through fiat channel',
        USDTcontractTips: 'Various contracts settled in USDT',
        FiatcurrencycontractTips: 'Various contracts settled in fiat currency',
        TransferTips: 'One click exchange for different cryptocurrency assets',
        c2cTips: 'Buy and sell cryptocurrencies through flexible payment methods with zero transaction fees',
    },
    forgotPass: {
        title: 'Reset Password',
        btn: 'Confirm',
        Password: 'New Password',
        placeholder: 'Please enter new password',
        success: 'Setup successful',
    },
    finance: {
        financeAssetAmount: 'Financial Asset Valuation',
        financeAccount: 'Financial Account',
        financefund: 'Financial Fund',
        financeProduct: 'Financial Product',
        Applynow: 'Apply Now',
        term: 'Term',
        investment: 'Investment Amount',
        Mininvestment: 'Minimum Investment',
        Maxinvestment: 'Maximum Investment Amount',
        buyNum: 'Purchase Count',
        Myincome: 'My Income',
        Dailyearnings: 'Daily Earnings',
        yieldmaturity: 'Maturity Earnings',
        timeaxis: 'Timeline',
        Subscriptiondate: 'Subscription Date',
        valuedate: 'Value Date',
        duedate: 'Due Date',
        Receiptdate: 'Receipt Date',
        day: 'Day',
        financeOrderList: 'Financial Record',
        interestrate: 'Interest Rate',
        Revenueamount: 'Revenue Amount',
        Settlementamount: 'Settlement Amount',
        regularly: 'Fixed-term',
        eecurrent: 'Demand',
        redemption: 'Redemption',
        redemptionTips: 'Confirm redemption of this financial product',
        loan: 'Loan',
        LoanRange: 'Loan range',
        LoanAmount: 'Loan amount',
        loanTerm: 'Loan term',
        Dailyinterestrate: 'Daily interest rate',
        Totalinterest: 'Total interest',
        Repaymentmethod: 'Repayment method',
        Repaymentofmaturity: 'Lump-sum repayment of principal and interest at maturity',
        Estimatedreturn: 'Estimated amount payable',
        Ihavereadandagree: 'I have read and agree',
        LoanAgreement: 'Loan agreement',
        Immediatelymoney: 'Borrow now',
        Minimumloanamount: 'Minimum loan amount',
        Maximumloanamount: 'Maximum loan amount',
        Applicationsuccessfulreview: 'Application successful, awaiting system review',
        Loanrecords: 'Loan records',
        Pendingreview: 'Pending review',
        issued: 'Issued',
        Repaid: 'Repaid',
        Rejected: 'Rejected',
        LoanDate: 'Loan date',
        AmountDue: 'Amount due',
        repayment: 'Repayment',
        loanTTips: 'Fast disbursement, multiple pledge duration options available',
        homeAddress: 'Detailed home address',
        homeAddressTips: 'Please enter the detailed home address',
        emergencyContact: 'Emergency contact',
        emergencyContactTips: 'Please enter the emergency contact',
        emergencyPhone: 'Emergency contact phone number',
        emergencyPhoneTips: 'Please enter the emergency contact phone number',
        emergencyEmail: 'Emergency contact email',
        emergencyEmailTips: 'Please enter the emergency contact email',
        isHouse: 'Do you own your own property',
        houseImg: 'If you own property, please provide an image of the ownership certificate',
        certImg: 'Front of ID (ID Card/Passport/Driver’s License)',
        certImgTips: 'Please upload the front of ID (ID Card/Passport/Driver’s License)',
        certBackImg: 'Back of ID (ID Card/Passport/Driver’s License)',
        certBackImgTips: 'Please upload the back of ID (ID Card/Passport/Driver’s License)',
        trustImg: 'Credit score screenshot',
        trustImgTips: 'Please upload the credit score screenshot',
        yesTxt: 'Yes',
        noTxt: 'No',
        EstimatedReturn: 'Estimated Return',
        seeDetail: 'View details',
        orderDetails: 'Order details',
    },
    heel: {
        tips: 'Stay tuned~',
    },
    home: {
        optional: 'Optional',
        HotList: 'Hot List',
        more: 'More',
        Capturetrading: 'Seize Trading Opportunities',
        Exploreproducts: 'Explore Our Products',
        Contracttrading: 'Contract Trading',
        Spottrading: 'manage money matters',
        ContracttradingTips: 'A highly popular leveraged derivative with up to 100x leverage. Supports both long and short positions—profit from market fluctuations.',
        SpottradingTips: 'Minimal cost, maximum returns. Trade anytime, anywhere.',
        starttrading: 'Start Trading',
        Tradeanytime: 'Trade Anytime, Anywhere',
        Scandownload: 'Scan to Download',
        hundredmillion: 'Billion',
        thousand: 'Ten Thousand',
        year: 'Year',
        transactionvolume: '24H Trading Volume',
        openinterest: '24H Open Interest',
        RegisteredUser: 'Registered Users',
        Ensuresafetyfunds: 'Ensuring Fund Security',
        Reasonschoosingus: 'Reasons to Choose Us',
        mobeginwith: 'Established in',
        Topliquidity: 'Top Liquidity',
        Effectivelyusers: 'Effectively Protecting User Rights',
        TradeNow: 'Trade Now',
        Needhelp: 'Need Help',
        helpcenter: 'Help Center',
        helpcenterTips: 'Get help with common issues and detailed explanations of specific features.',
        Learnmore: 'Learn More',
        Onlinecustomerservice: 'Online Customer Service',
        OnlinecustomerserviceTips: '24/7 customer support—available anytime, anywhere.',
        PlatformAnnouncement: 'Platform Announcements',
        PlatformAnnouncementTips: 'Get the latest updates and stay informed about trading opportunities.',
        Starttradingnow: 'Start Your Cryptocurrency Trading Journey Now!',
        Trademillions: 'Trade on a Platform Trusted by Millions of Users',
        Storingbuyingcoins: 'Deposit or Buy Crypto',
        product: 'Products',
        service: 'Services',
        guide: 'Guide',
        agreedannouncement: 'Agreement & Statement',
        customerservice: 'Customer Service',
        Riskstatement: 'Risk Disclaimer: Cryptocurrency trading is an emerging industry with great potential, but as a new field, it also comes with significant risks. Especially in leveraged trading, leverage magnifies both potential gains and risks. Please ensure that you fully understand the industry, leverage trading models, and trading rules before participating. We strongly recommend that you only trade within the risk level you can bear. Trading involves risks—proceed with caution!',
        topTips: 'One account, unlimited possibilities',
        coin: 'Spot Trading',
        coinTips: 'Instant and transparent, start your spot trading journey anytime, anywhere',
    },
    login: {
        title: 'Login',
        Account: 'Login Account',
        Password: 'Password',
        btn: 'Login',
        placeholder: 'Please enter phone number',
        placeholder1: 'Please enter password',
        ForgotPassword: 'Forgot Password',
        noAccount: 'No account?',
        Registration: 'Register',
        server: 'Contact Support',
        success: 'Login Successful',
        checkedAgree: 'Please agree to the Privacy Agreement first',
        rememberpassword: 'Remember Password',
        agreewith: 'Agree',
        PrivacyAgreement: 'Privacy Agreement',
    },
    market: {
        product: 'Product',
        Latestprice: 'Latest Price',
        volume: 'Volume',
        ChangeRatio: 'Chg Rate',
        Addoptional: 'Add to Optional',
        optional: 'Optional',
        market: 'Market',
        Editselfselection: 'Edit Optional',
        operate: 'Operate',
        SelectAll: 'Select All',
        delete: 'Delete',
        time: 'Time',
    },
    position: {
        title: 'Position Details',
        totalassets: 'Total Assets',
        profitloss: 'Profit/Loss',
        Holdingassets: 'Holding Assets',
        margin: 'Margin',
        orderAmount: 'Order Amount',
        availableassets: 'Available Assets',
        product: 'Product',
        direction: 'Direction',
        Entrustedprice: 'Entrusted Price',
        Entrustednum: 'Entrusted Quantity',
        Currentprice: 'Current Price',
        Stoplossprice: 'Stop Loss Price',
        stopSurplusPrice: 'Take Profit Price',
        Leverageratio: 'Leverage Ratio',
        Entrustedtime: 'Entrusted Time',
        orderno: 'Order Number',
        marketvalue: 'Market Value',
        SettlementPrice: 'Settlement Price',
        Settlementtime: 'Settlement Time',
        Settakeprofitloss: 'Set Profit/Loss',
        closeposition: 'Close Position',
        Position: 'Current Orders',
        commission: 'Historical Orders',
        Settlement: 'Historical transactions',
        Settingsuccessful: 'Settings Successful',
        Confirmclosingorder: 'Confirm closing order',
        Closingsuccessfully: 'Closed successfully',
        cancelorder: 'Confirm cancel order',
        Cancelsuccessfully: 'Cancel successful',
        status: 'Status',
        changeRate: 'Fee',
    },
    property: {
        title: 'Asset Details',
        totalassets: 'Total Assets',
        profitloss: 'Profit/Loss',
        Holdingassets: 'Holding Assets',
        margin: 'Margin',
        availableassets: 'Available Assets',
        investmentportfolio: 'Investment Portfolio',
        Recentincomesituation: 'Recent Income Situation',
        Seemore: 'See More',
        IncomeDetails: 'Income Details',
    },
    recharge: {
        mixAmount: 'Minimum recharge amount',
        subMsg: 'Submitted successfully, please wait for review',
        amountMsg: 'Please enter amount',
        VoucherMsg: 'Please upload payment voucher',
        Depositcoins: 'Deposit Coins',
        Rechargecurrency: 'Recharge Currency',
        RechargecurrencyTips: 'Deposit over 200USDT for fast arrival',
        Depositaddress: 'Deposit Address',
        Rechargetoaccount: 'Recharge to Account',
        Walletaccount: 'Wallet Account',
        Rechargequantity: 'Recharge Quantity',
        Paymentvoucher: 'Payment Voucher',
        Youneedtorecharge: 'You need to recharge',
        Rechargenow: 'Recharge Now',
        Rechargefiatcurrency: 'Fiat Deposit',
        Topupfiatcurrency: 'Top Up Fiat',
        paymentcurrency: 'Payment Currency',
        paymentcurrencyTips: 'Deposit over 200USD for fast arrival',
        Fiatcontractaccount: 'Fiat Contract Account',
        Rechargeamount: 'Recharge Amount',
        Youwillget: 'You will receive',
        network: 'Network',
        notsupportedAddress: 'Current address not supported',
        selectaccount: 'Please select an account',
    },
    register: {
        title: 'Register',
        send: 'Send Verification Code',
        Resend: 'Resend',
        sendSuccess: 'Sent successfully',
        PhoneNumber: 'Phone Number',
        Mailbox: 'Email',
        Captcha: 'Captcha',
        Password: 'Password',
        ConfirmPassword: 'Confirm Password',
        PromoteCode: 'Referral Code',
        OrgCode: 'Organization Code',
        btn: 'Register',
        placeholder0: 'Please enter phone number',
        placeholder1: 'Please enter password',
        placeholder2: 'Please confirm password',
        placeholder3: 'Please enter referral ID',
        placeholder4: 'Please enter captcha',
        placeholder5: 'Please enter email',
        emaiError: 'Invalid email format',
        success: 'Registration successful',
        message: 'Password must be at least 6 characters',
        message1: 'Confirm password must be at least 6 characters',
        message2: 'Passwords do not match',
        searchCountryMsg: 'Please search by country or code',
        haveAccount: 'Already have an account?',
        goLogin: 'Login',
        titleTips: 'Start from registration!',
        Invitationcode: 'Invitation Code',
        Iagreewith: 'By creating an account, I agree to ',
        and: 'and',
    },
    safe: {
        SecuritySettings: 'Security Settings',
        Accountsecurity: 'Account Security',
        phone: 'Phone',
        Notyetbound: 'Not Bound',
        mailbox: 'Mailbox',
        Loginpassword: 'Login Password',
        Fundcode: 'Fund Password',
        Settings: 'Settings',
        Withdrawaladdressmanagement: 'Withdrawal Address Management',
        Addwithdrawaladdress: 'Add Withdrawal Address',
        Withdrawalcurrency: 'Withdrawal Currency',
        Withdrawaladdress: 'Withdrawal Address',
        WithdrawaladdressTips: 'Please enter withdrawal address',
        remark: 'Remark',
        confirm: 'Confirm',
        Addedsuccessfully: 'Added successfully',
        Pleaseselectcurrency: 'Please select currency',
        Bindmailbox: 'Bind Email',
        Bindmobilephone: 'Bind Mobile Phone',
        ChangeLoginPassword: 'Change Login Password',
        Setfundpassword: 'Set Fund Password',
        BindmailboxTips: 'Please bind email first, bind now?',
        Addnewaddress: 'Add New Address',
        Confirmdeleteaddress: 'Confirm delete withdrawal address',
    },
    share: {
        title: 'Share to Earn',
        commission: 'Commission',
        Commissionrecord: 'Commission Record',
        Commissiontransferout: 'Commission Transfer Out',
        Transferoutrecord: 'Transfer Out Record',
        Invitefriends: 'Invite Friends',
        Invitationrecord: 'Invitation Record',
        Commissioncommission: 'Commission Share',
        ReferralCode: 'Referral Code',
        Firstlevelmembers: 'Level 1 Members',
        Secondlevelmembers: 'Level 2 Members',
        Thirdlevelmembers: 'Level 3 Members',
        Transferbalance: 'Transfer to Balance',
        Confirmtransferout: 'Confirm Transfer Out',
        Transfersuccessful: 'Transfer Successful',
        amount: 'Transfer Amount',
        Transferfiaaccount: 'Transfer to Fiat Account',
    },
    trade: {
        high: '24h High Price',
        low: '24h Low Price',
        vol: '24h Volume',
        buy: 'Buy',
        sell: 'Sell',
        buyBtn: 'Buy',
        sellBtn: 'Sell',
        Present: 'Market Order',
        Limit: 'Limit Order',
        limitMsg: 'Price',
        markPriceMsg: 'At the current best price',
        num: 'Quantity',
        zyzsSet: 'Set Loss/Profit',
        zyPrice: 'Take Profit',
        zsPrice: 'Stop Loss',
        smallMin: 'M',
        hour: 'H',
        dayMin: 'D',
        Position: 'Position',
        Viewalltransactions: 'View All Transactions',
        product: 'Product',
        direction: 'Direction',
        Entrustedprice: 'Entrusted Price',
        Entrustednum: 'Entrusted Quantity',
        Latestprice: 'Latest Price',
        volume: 'Volume',
        ChangeRatio: 'Change Percentage',
        buyBtnConfirm: 'Confirm Buy',
        sellBtnConfirm: 'Confirm Sell',
        totalAmount: 'Amount',
        Margin: 'Margin',
        balance: 'Available',
        buyLimtMsg: 'Buy only at a lower price than the market',
        sellLimtMsg: 'Sell only at a higher price than the market',
        putNummsg: 'Enter quantity',
        putLimitPriceMsg: 'Enter limit price',
        pleaseAuth: 'Please verify first',
        orderSuccess: 'Transaction Success',
        Fullwarehouse: 'Full Position',
        corkado: 'Can Open Long',
        Kato: 'Open Long',
        openable: 'Can Open Short',
        Openempty: 'Open Short',
        purchasable: 'Can Buy',
        vendibility: 'Can Sell',
        Orderconfirmation: 'Confirm Order',
        Averageopeningprice: 'Average Opening Price',
        Marketprice: 'Market Price',
        Openingquantity: 'Opening Quantity',
        Stoplossprice: 'Stop Loss Price',
        stopSurplusPrice: 'Take Profit Price',
        Averageprice: 'Average Price',
        buyLimtMsg2: 'Buy only at a lower price than the market',
        sellLimtMsg2: 'Sell only at a higher price than the market',
        authTips: 'Please authenticate first',
        profundity: 'Depth',
        deal: 'Deal',
        contract: 'Contract',
        TradeNow: 'Trade Now',
        CloseTime: 'Closed Market',
        buyUp: 'Buy Up',
        buyDown: 'Buy Down',
        selectSeconds: 'Select Expiration Time',
        buyNums: 'Purchase Amount',
        minbuyNums: 'Minimum Buy',
        incomeRates: 'Income Rate',
        buySuccessTips: 'Purchase Successful',
        secondNums: 'Seconds',
        simulatedTrading: 'Simulated Trading',
    },
    upPassword: {
        title: 'Change Password',
        oldPassword: 'Old Password',
        oldPasswordMsg: 'Enter old password',
        newPassword: 'New Password',
        newPasswordMsg: 'Enter new password',
        twoPassword: 'Confirm Password',
        twoPasswordMsg: 'Enter confirm password',
        twoinputMsg: 'Passwords do not match',
        passwordTypeMsg: 'Password must be 6 digits',
        submsg: 'Change Successful',
        btn: 'Confirm Change',
    },
    user: {
        Avatarchange: 'Change Avatar',
        Replacesuccessfully: 'Change Successful',
        authenticated: 'Authenticated',
        Notcertifiedyet: 'Not Certified',
        Invitefriends: 'Invite Friends',
        Activecenter: 'Activity Center',
        Identityauthentication: 'Identity Authentication',
        Completedverification: 'Verified',
        Tobeverified: 'Pending Verification',
        SecuritySettings: 'Security Settings',
        Lang: 'Select Language',
        changeTheme: 'Change Skin',
        helpcenter: 'Help Center',
        Aboutus: 'About Us',
        out: 'Logout',
        outmsg: 'Confirm Logout',
        trustscore: 'Credit score',
    },
    welcome: {
        title1: 'Industry-Leading Market Liquidity',
        tips1: '99% of orders executed at the best price',
        title2: '12 Years of Trust',
        tips2: 'Trade crypto anytime on a reliable platform',
        title3: 'VIP Exclusive Benefits',
        tips3: 'Become VIP to enjoy fee discounts on trading, exchange, and withdrawals',
        title4: '100,000 USDT for Simulated Trading',
        tips4: 'Risk-free practice trading',
        bnt1: 'Register and Get 10 USDT',
        bnt2: 'Login',
    },
    with: {
        Withdrawcurrency: 'Withdraw',
        currencyofwithdrawal: 'Withdrawal Currency',
        Withdrawaladdress: 'Withdrawal Address',
        Addwithdrawaladdress: 'Add Withdrawal Address',
        Withdrawalquantity: 'Withdrawal Quantity',
        availablebalance: 'Available Balance',
        WithdrawaladdressTips: 'No withdrawal address set for this currency, set now?',
        selectWithdrawaladdress: 'Select Withdrawal Address',
        Insufficientavailablebalance: 'Insufficient Balance',
        Withdrawingfiatcurrency: 'Withdraw Fiat',
        Withdrawaloffiatcurrency: 'Withdraw Fiat Currency',
        Currentbalance: 'Current Balance',
        Currencyreceived: 'Currency Received',
        WithdrawingfiatcurrencyTips: 'Withdrawals over 200 USD are processed quickly',
        Withdrawalaccount: 'Withdrawal Account',
        Fiatcontractaccount: 'Fiat Contract Account',
        Withdrawalamount: 'Withdrawal Amount',
        Youneedwithdrawmoney: 'You need to withdraw',
        Youwillget: 'You will receive',
        Withdrawimmediately: 'Withdraw Now',
        mixAmount: 'Min Withdrawal Amount ',
        subMsg: 'Submission successful, please wait for review',
    },
}